export enum FIELDS {
  COMMISSION_ID = 'id',
  COMMISSION_TERM_TYPE = 'type',
  COMMISSION_NAME = 'name',
  FEE = 'fee',
  UPFRONT_FEE = 'upfrontFee',
  ONGOING_FEE = 'ongoingFee',
  FEE_END_DATE = 'feeEndDate',
  PRODUCTS = 'products',
  FILTERS = 'filters',
}

export enum FIELDS_LABELS {
  COMMISSION_TERM_TYPE = 'Commission Type',
  COMMISSION_NAME = 'Name',
  FEE = 'Fee value',
  UPFRONT_FEE = 'Upfront fee value',
  ONGOING_FEE = 'Ongoing fee value',
  FEE_END_DATE = 'Fee end date',
  PRODUCTS = 'Products',
}

export enum FILTER_NAMES {
  PRODUCT_TIER = 'productTier',
  PURPOSE_OF_THE_LOAN = 'purposeOfTheLoan',
  PRODUCT_TYPE = 'productType',
  FIXED_RATE_LENGTH = 'fixedRateLength',
}

export enum COMMISSION_TYPE {
  STANDARD = 'STANDARD',
  ONGOING = 'ONGOING',
  ENHANCED = 'ENHANCED',
}

export enum FILTER_LABELS {
  PURCHASE_TYPE = 'Mortgage type',
  PRODUCT_TYPE = 'Product type',
  FIXED_RATE_TERM = 'Fixed term rate',
  PRODUCT_TIER = 'Product group',
}
